import { createAction } from 'redux-actions';
import {
	GET_PERSONAL_PAYROLL_DETAIL_CALL,
	GET_PERSONAL_PAYROLL_DETAIL_DONE,
	GET_PERSONAL_PAYROLL_DETAIL_FAIL,
	GET_PERSONAL_PAYROLL_LIST_CALL,
	GET_PERSONAL_PAYROLL_LIST_DONE,
	GET_PERSONAL_PAYROLL_LIST_FAIL,
	GET_PAYSLIP_DISPLAY_SETTINGS_CALL,
	GET_PAYSLIP_DISPLAY_SETTINGS_DONE,
	GET_PAYSLIP_DISPLAY_SETTINGS_FAIL,
	GET_PAYROLL_TASK_DISPLAY_SETTINGS_CALL,
	GET_PAYROLL_TASK_DISPLAY_SETTINGS_DONE,
	GET_PAYROLL_TASK_DISPLAY_SETTINGS_FAIL,
} from '@src/store/types/payroll';

export const getPersonalPayrollListCall = createAction(GET_PERSONAL_PAYROLL_LIST_CALL);
export const getPersonalPayrollListDone = createAction(GET_PERSONAL_PAYROLL_LIST_DONE);
export const getPersonalPayrollListFail = createAction(GET_PERSONAL_PAYROLL_LIST_FAIL);

export const getPersonalPayrollDetailCall = createAction(GET_PERSONAL_PAYROLL_DETAIL_CALL);
export const getPersonalPayrollDetailDone = createAction(GET_PERSONAL_PAYROLL_DETAIL_DONE);
export const getPersonalPayrollDetailFail = createAction(GET_PERSONAL_PAYROLL_DETAIL_FAIL);

export const getPayslipDisplaySettingsCall = createAction(GET_PAYSLIP_DISPLAY_SETTINGS_CALL);
export const getPayslipDisplaySettingsDone = createAction(GET_PAYSLIP_DISPLAY_SETTINGS_DONE);
export const getPayslipDisplaySettingsFail = createAction(GET_PAYSLIP_DISPLAY_SETTINGS_FAIL);

export const getPayrollTaskDisplaySettingsCall = createAction(GET_PAYROLL_TASK_DISPLAY_SETTINGS_CALL);
export const getPayrollTaskDisplaySettingsDone = createAction(GET_PAYROLL_TASK_DISPLAY_SETTINGS_DONE);
export const getPayrollTaskDisplaySettingsFail = createAction(GET_PAYROLL_TASK_DISPLAY_SETTINGS_FAIL);
